import jsPDF from "jspdf";
import { RangedKanaalAssign } from "../props/PropTypes";
import { HwdSysteem } from "../kanaal/hdw-config/HdwSysteem";
import { A3MM, A4MM, BasePDFNode, getYoga, RectPDFNode, TextPDFNode } from "./BasePDFNode";
import { IOKlemPDFNode } from "./KaartPDFNode";
import { TranslateService } from "../i18n/translate.service";

export class MainboardPDFNode extends BasePDFNode {
    constructor(public pdf: jsPDF, public translateService: TranslateService, public kanaalMap: Record<string, Array<Array<RangedKanaalAssign>>>,
        public system: HwdSysteem) {

        super(pdf,{
            flexDirection: 'column',
            flexGrow: 1,
            margin: 2,
            padding: 2,

        },  getYoga().Node.create());
    }

    public init(): void {
        let txt = this.addChild2(new TextPDFNode(this.pdf, {
            fontSize: 12,
            marginBottom: 2
        }));
        let repo = this.translateService.translateSignal();
        txt.text = this.translateService.getTranslationSync(repo, 'pdf', 'Mainboard {mainboard}', 'Mainboard {mainboard}', { mainboard: this.system.mainboard.label });
        let c = this.addChild2(new BasePDFNode(this.pdf,  {
            flexDirection: 'row',
            flexWrap: 'wrap',
            // padding: 1,
            columnGap: 1,
            flexGrow: 1
        }));
        let hdwLayout = this.system.getHdwLayout();
        for (let row of hdwLayout) {
            let rowNode = c.addChild2(new RectPDFNode(this.pdf,  {
                flexDirection: 'column',
            }));
            let klmNode = rowNode.addChild2(new IOKlemPDFNode(this.pdf, this.kanaalMap, row));
            klmNode.style.maxWidth = 88;

        }
        super.init();
    }

    public render(): void {
        // this.layout.calculateLayout(A3MM.height, A3MM.width);
        this.layout.calculateLayout(A3MM.width, A3MM.height);
        let l = this.layout.getComputedLayout();
        let topLeft = this.getTopLeft();
        this.pdf.rect(topLeft.x, topLeft.y, l.width, l.height);

        super.render();

    }

}